import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h1" }
const _hoisted_4 = { class: "_mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.Resources.Contact.PageTitle), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.Resources.Contact.PageSubtitle), 1 /* TEXT */)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent($options.component.name), _mergeProps({
      key: $options.component.key
    }, $options.component.props, {
      onError: $options.onError,
      onBack: $options.onBack
    }), null, 16 /* FULL_PROPS */, ["onError", "onBack"]))
  ]))
}